import { EmployeeFormFields } from 'src/components/enterprise/features/Employee/components/Form/types/EmployeeForm';

export function transformLocationUIToModel(
  values: Partial<EmployeeFormFields>
): Partial<EmployeeFormFields> {
  const { locationId, ...rest } = values;

  // Only include locationId if it has a value
  if (locationId) {
    return values;
  }

  return rest;
}
